import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import SelectField from "../../../../Components/Masters/SelectField";
import countries from "../../Roles and Permissions/Country.json";
import EditDialog from "../../../../Components/Common/EditDialog";
import { post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";

const FRANCHISE_TYPE_OPTIONS = [
  "Food & Beverage",
  "Retail - Clothing & Apparel",
  "Retail - Electronics",
  "Retail - Grocery / Supermarket",
  "Hospitality",
  "Fitness & Wellness",
  "Healthcare",
  "Education",
  "Automotive",
  "Entertainment",
];

function AddFranchise({
  formInputData,
  fetchData,
  id,
  element,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  embedded = false,
  embeddedTitle = "",
}) {
  const [errors, setErrors] = useState({});

  const buildInitialState = () => ({
    franchiseName: element?.franchiseName || "",
    franchiseId: element?.franchiseId || "",
    country: element?.country || "",
    locationAddress: element?.locationAddress || "",
    contactPerson: element?.contactPerson || "",
    franchiseType: element?.franchiseType || "",
  });

  const [formData, setFormData] = useState(buildInitialState);
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState(buildInitialState);

  useEffect(() => {
    const next = buildInitialState();
    setFormData(next);
    setFormData2(next);
  }, [element, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    if (name === "franchiseId") {
      const dup = data?.filter(
        (el) => el.franchiseId?.toLowerCase() === value?.toLowerCase(),
      );
      if (dup?.length > 0 && (element ? element._id !== dup[0]._id : true)) {
        setErrors((prev) => ({
          ...prev,
          franchiseId: "Franchise ID already exists.",
        }));
      }
    }
  };

  const handleCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setErrors((prev) => ({ ...prev, country: "" }));
    setFormData((prev) => ({
      ...prev,
      country: selectedCountry === "Tap to select" ? "" : selectedCountry,
    }));
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    const cleared = buildInitialState();
    setFormData(cleared);
    setFormData2(cleared);
  };

  const handleClose = () => {
    const unchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key],
    );
    if (unchanged) handleExitAgree();
    else setEditDialog(true);
  };

  const validateForm = () => {
    const next = { ...errors };
    formInputData.forEach((input) => {
      const value = formData[input.fieldName];
      if (!value || String(value).trim() === "") {
        next[input.fieldName] = `${input.title} is required`;
      } else {
        delete next[input.fieldName];
      }
    });

    setErrors(next);
    return !Object.keys(next).some((k) => next[k]);
  };

  const Save = async () => {
    if (!validateForm()) return;
    const payload = {
      franchiseName: formData.franchiseName.trim(),
      franchiseId: formData.franchiseId.trim(),
      country: formData.country,
      locationAddress: formData.locationAddress.trim(),
      contactPerson: formData.contactPerson.trim(),
      franchiseType: formData.franchiseType,
    };

    const request = id
      ? put(`${updateUrl}?Id=${id}`, payload)
      : post(addUrl, payload);

    await request
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response?.data?.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        } else {
          setsnackOpen({
            open: true,
            message: err?.response?.data?.message || "Something went wrong",
            severity: "error",
          });
        }
      });
  };

  const renderField = (el) => {
    if (el.fieldName === "country") {
      return (
        <SelectField
          key={el.fieldName}
          title={el.title}
          name={el.fieldName}
          value={formData.country}
          handleChange={handleCountryChange}
          options={countries.countries}
          errors={errors[el.fieldName]}
        />
      );
    }

    if (el.fieldName === "franchiseType") {
      return (
        <SelectField
          key={el.fieldName}
          title={el.title}
          name={el.fieldName}
          value={formData.franchiseType}
          handleChange={handleChange}
          options={FRANCHISE_TYPE_OPTIONS}
          errors={errors[el.fieldName]}
        />
      );
    }

    return (
      // <Box key={el.fieldName}>
      //   <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
      //     {el.title}
      //   </Typography>
      //   <TextField
      //     size="small"
      //     fullWidth
      //     variant="outlined"
      //     name={el.fieldName}
      //     value={formData[el.fieldName] || ""}
      //     onChange={handleChange}
      //     placeholder={el.placeholder}
      //     disabled={Boolean(el.disabled)}
      //     error={Boolean(errors[el.fieldName])}
      //     helperText={
      //       typeof errors[el.fieldName] === "string" ? errors[el.fieldName] : ""
      //     }
      //   />
      // </Box>
      <InputField
        key={el.fieldName}
        title={el.title}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        disabled={Boolean(el.disabled)}
      />
    );
  };

  const drawerList = () => (
    <Box display="flex" gap={3} sx={{ width: "28rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "90%",
          p: 3,
          backgroundColor: "#fff",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Franchise" : "Add Franchise"}
        </Typography>
        {formInputData.map((el) => renderField(el))}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  const embeddedList = () => (
    <Box
      sx={{
        width: "100%",
        p: 0,
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold" }}
        >
          {embeddedTitle || (id ? "Edit Franchise" : "Add Franchise")}
        </Typography>
      </Box>
      {formInputData.map((el) => renderField(el))}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0a3f73",
            textTransform: "none",
            mt: 1,
            mb: 6,
          }}
          onClick={Save}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );

  if (embedded) {
    return addData ? embeddedList() : null;
  }

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        height: "100vh",
        minHeight: "100vh",
        overflowY: "auto",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {drawerList()}
    </Drawer>
  );
}

export default AddFranchise;
